<template>
  <div class="content-item">
    <h2 class="heading">Film the Pastor Introduction Video</h2>
    <p class="text">
      So happy that your cards made it to you! Now it is time to film your invitation video. Please make sure you have your cards ready. Watch the instruction video and make sure you practice
      memorizing your script, especially when you are holding up your invitation card referencing it.
    </p>
    <div class="radio-group">
      <div class="row">
        <p class="text"><a class="link-button" href="https://mytruelife.org/welcome-video" target="new">Click Here</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'Step8',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    doSelectCard(card) {
      this.$emit('onSelectCard', card);
    },
    doSetCardSelected(card) {
      this.selected = card;
      setTimeout(() => {
        this.$emit('onNextPage');
      }, 500);
    },
    submit() {
      this.$emit('input', {
        ...this.value,
        card_back: this.selected.id,
      });
    },
  },
};
</script>
